import { getUserData, hasUserData } from './types';
export function removeNonMeasurableObjects(root) {
    const measurableObject = root;
    const toDelete = [];
    measurableObject.traverse((node) => {
        const takePlace = getUserData(node).takePlace;
        if (hasUserData(node) && !takePlace) {
            toDelete.push(node);
        }
    });
    for (const node of toDelete) {
        node.removeFromParent();
    }
    return measurableObject;
}
export function getMeasurableObjects(root) {
    const measurableObject = root.clone(true);
    return removeNonMeasurableObjects(measurableObject);
}
//# sourceMappingURL=scene-utils.js.map